import { Routes } from '@angular/router';
import { Articles } from './components/articles/articles';
import { Careers } from './components/careers/careers';
import { Products } from './components/products/products';
import { Categories } from './components/categories/categories';
import { Article } from './components/article/article';
import { Tags } from './components/tags/tags';
import { PageNotFound } from './components/page-not-found/page-not-found';
import { Contacts } from './components/contacts/contacts';
import { Authors } from './components/authors/authors';
import { Home } from './components/home/home';
import { Career } from './components/career/career';
import { Product } from './components/product/product';
import { Featured } from './components/featured/featured';
import { PrivacyPolicy } from './components/privacy-policy/privacy-policy';
import { TermsOfUse } from './components/terms-of-use/terms-of-use';

export const routes: Routes = [
    {
        path: '',
        component: Home,
    },
    {
        path: 'products',
        component: Products
    },
    {
        path: 'product/:slug',
        component: Product,
    },
    {
        path: 'articles/:limit/:page',
        component: Articles
    },
    {
        path: 'featured/:limit/:page',
        component: Featured
    },
    {
        path: 'article/:category/:slug',
        component: Article
    },
    {
        path: 'categories/:slug/:limit/:page',
        component: Categories
    },
    {
        path: 'tags/:slug/:limit/:page',
        component: Tags
    },
    {
        path: 'authors/:slug/:limit/:page',
        component: Authors
    },
    {
        path: 'careers',
        component: Careers
    },
    {
        path: 'career/:slug',
        component: Career
    },
    {
        path: 'contacts',
        component: Contacts
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicy
    },
    {
        path: '**',
        component: PageNotFound,
    }
];
